import { render } from "./AppDatatableSkeleton.vue?vue&type=template&id=450e476d&scoped=true"
const script = {}

import "./AppDatatableSkeleton.vue?vue&type=style&index=0&id=450e476d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450e476d"]])

export default __exports__